import User from '~/auth/User';

export default class GroupHashHelper {
  private static readonly GROUP_HASH_STORAGE_KEY = 'gh';

  public static getGroupHash(): string {
    return this.getSelectedGroupHash() || User.getGroupHash();
  }

  public static getSelectedGroupHash(): string {
    return this.getStorageValue(this.GROUP_HASH_STORAGE_KEY);
  }

  public static setSelectedGroupHash(selectedGroupHash: string) {
    localStorage.setItem(this.GROUP_HASH_STORAGE_KEY, selectedGroupHash);
  }

  public static removeSelectedGroupHash() {
    localStorage.removeItem(this.GROUP_HASH_STORAGE_KEY);
  }

  private static getStorageValue(key: string): string {
    return localStorage.getItem(key) ?? '';
  }
}
